import Text from "../../../components/ui/Text";
import { useAudioEffects } from "../../../hooks/use-audio-effects";
import clickSound from "../../../assets/audio/click.wav";
import { GameStats } from "../hooks/use-pairs-game";

interface Props {
  className?: string;
  isLevelComplete: boolean;
  stats: GameStats;
  isGameOver: boolean;
  isRunning: boolean;
  gridSize: number;
  resetGame: () => void;
  nextLevel: () => void;
  startGame: () => void;
}

const Scenarios = ({
  isGameOver,
  isLevelComplete,
  gridSize,
  stats,
  isRunning,

  nextLevel,
  startGame,
  resetGame,
}: Props) => {
  const { playEffect } = useAudioEffects();

  return (
    <div
      className={`absolute top-0 left-0 flex-col w-full h-full flex bg-black/50 rounded-[56px] items-center justify-center`}
    >
      {isGameOver && (
        <div className="text-center">
          <Text className="text-red-500 uppercase font-bold" size="3xl">
            GAME OVER
          </Text>
          <Text className="text-red-300 font-bold" size="md">
            Time has expired
          </Text>
        </div>
      )}

      {isLevelComplete && (
        <div className="text-center">
          <Text className="text-green-500 uppercase font-bold" size="3xl">
            LEVEL COMPLETED
          </Text>
        </div>
      )}
      {isGameOver ||
        (isLevelComplete && (
          <div className="grid grid-cols-3 gap-10 text-white">
            {/** Seconds */}
            <div className="text-center gilroy-font ">
              <Text>Seconds left</Text>
              <Text size="xl">{stats.timeLeft}s</Text>
            </div>
            {/** Moves */}
            <div className="text-center">
              <Text>Moves</Text>
              <Text size="xl">{stats.moves}</Text>
            </div>
            {/** Matches */}
            <div className="text-center">
              <Text>Matches</Text>
              <Text size="xl">
                {stats.matches === gridSize ? "All" : stats.matches}
              </Text>
            </div>
          </div>
        ))}

      {isGameOver && (
        <button
          onClick={resetGame}
          title="Reset game"
          className="bg-red-500 text-white text-2xl transition hover:bg-white hover:text-red-500 hover:scale-95 px-8 py-3 rounded-md mt-5"
        >
          Reset game
        </button>
      )}
      {isLevelComplete && (
        <button
          onClick={() => {
            nextLevel();
            playEffect(clickSound);
          }}
          title="Next-level"
          className="bg-green-500 text-white text-2xl transition hover:bg-white hover:text-green-500 hover:scale-95 px-8 py-3 rounded-md mt-5"
        >
          Go to next level
        </button>
      )}
      {!isRunning && !isGameOver && !isLevelComplete && (
        <button
          onClick={() => {
            startGame();
            playEffect(clickSound);
          }}
          title="Start"
          className="bg-blue-500 text-white text-2xl transition hover:bg-white hover:text-blue-500 hover:scale-95 px-8 py-3 rounded-md mt-5"
        >
          Start game
        </button>
      )}
    </div>
  );
};

export default Scenarios;
